import {
    executeReactiveFormRequestAdapter,
    type ReactiveFormRequestAdapter,
    type ReactiveFormRequestAdapterContext,
    type ReactiveFormRequestAdapterState,
    type ReactiveFormRequestId,
    type ReactiveFormRequestOperation,
} from '../../adapters/reactive-form-request.adapter';

export interface ReactiveFormSubmitAdapterExecutorConfiguration<
    TPayload,
    TResponse,
    TId extends ReactiveFormRequestId = ReactiveFormRequestId,
> {
    readonly adapter: ReactiveFormRequestAdapter<TPayload, TResponse, TId>;
    readonly operation: ReactiveFormRequestOperation;
    readonly payload?: TPayload;
    readonly id?: TId | null;
    readonly state: ReactiveFormRequestAdapterState;
}

/**
 * Executes adapter-based submit requests and keeps adapter state mutations centralized.
 */
export class ReactiveFormSubmitAdapterExecutor<
    TPayload,
    TResponse,
    TId extends ReactiveFormRequestId = ReactiveFormRequestId,
> {
    public execute(configuration: ReactiveFormSubmitAdapterExecutorConfiguration<TPayload, TResponse, TId>): Promise<TResponse> {
        return executeReactiveFormRequestAdapter(
            configuration.adapter,
            this.createContext(configuration),
            configuration.state,
        );
    }

    private createContext(
        configuration: ReactiveFormSubmitAdapterExecutorConfiguration<TPayload, TResponse, TId>,
    ): ReactiveFormRequestAdapterContext<TPayload, TId> {
        let context: ReactiveFormRequestAdapterContext<TPayload, TId> = {
            operation: configuration.operation,
        };

        if (configuration.payload !== undefined) {
            context = {
                ...context,
                payload: configuration.payload,
            };
        }

        if (configuration.id !== undefined) {
            context = {
                ...context,
                id: configuration.id,
            };
        }

        return context;
    }
}
